import React, {useEffect, useState} from "react";
import moment from "moment";

const CurrentOffersComponent = (props) => {

    const {
        offersBatch,
        selectedDates,
        dateShown,
        setDateShown,
        offersFound,
        selectedDepartment,
        selectedStation
    } = props;
    
    const [filteredList, setFilteredList ] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSelectDate = (date) => {
        let filtered = offersBatch?.vtoOffers?.filter(offer => {
            const offerDate = moment(offer.offerStartDate).format("MM/DD/YYYY");
            return offerDate === date;
        }) || [];
        setDateShown(date);
        setFilteredList(filtered);
    }

    useEffect(() => {
        const hasRequiredFields = selectedDates?.length > 0 && selectedDepartment?.length > 0 && selectedStation?.length > 0;
        if (hasRequiredFields && !shouldRender) {
            setShouldRender(true);
            setIsLoading(true);
            setTimeout(() => setIsVisible(true), 10);
        } else if (!hasRequiredFields && shouldRender) {
            setIsVisible(false);
            setTimeout(() => setShouldRender(false), 800);
        }
    }, [selectedDates, selectedDepartment, selectedStation]);

    useEffect(() => {
        if (shouldRender) {
            if (offersBatch?.vtoOffers !== undefined) {
                setIsLoading(false);
                const hasOffers = offersBatch.vtoOffers.length > 0;
                if (hasOffers) {
                    if (dateShown && selectedDates.includes(dateShown)) {
                        handleSelectDate(dateShown);
                    } else {
                        handleSelectDate(selectedDates[0]);
                    }
                } else {
                setFilteredList([]);
            }
            } else {
                setIsLoading(true);
            }
        }
    }, [offersBatch, selectedDates, dateShown, shouldRender]);

    useEffect(() => {
        if (dateShown && offersBatch?.vtoOffers && selectedDates?.includes(dateShown)) {
            handleSelectDate(dateShown);
        }
    }, [dateShown]);

    if (!shouldRender) {
        return null;
    }

    return (
        <aside className={`current-offers-modal ${isVisible ? 'open' : ''}`}>
            <p className="subtitle">
                Current Offers Available
            </p>
            {isLoading ? (
                <div className="loading-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px',
                    width: '100%'
                }}>
                    <div className="spinner" style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '50%',
                        borderTop: '4px solid #0078d2',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                </div>
            ) : (
                <>
                    <div style={{display: 'flex'}}>
                        {selectedDates?.map(date => {
                            const handleSelect = () => {
                                handleSelectDate(date);
                            }
                            const dateHasOffers = offersBatch?.vtoOffers?.some(offer => {
                                const offerDate = moment(offer.offerStartDate).format("MM/DD/YYYY");
                                return offerDate === date;
                            }) || false;
                            return (
                                <div key={date} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 8,}}>
                                    <div
                                        className={`date-title ${date === dateShown ? "activeDate" : ""} ${!dateHasOffers ? "no-offers" : ""}`}
                                        data-value={date}
                                        onClick={handleSelect}
                                        style={{
                                            opacity: !dateHasOffers ? 0.6 : 1,
                                            cursor: 'pointer',
                                            marginBottom: 0
                                        }}
                                    >
                                        <p style={{ marginBottom: 0 }}>
                                            {date}</p>
                                    </div>
                                {!dateHasOffers && (
                                    <span className="no-offers-note">
                                        No offers
                                    </span>
                                )}
                                </div>
                            );
                        })}
                    </div>
                    <div style={{maxHeight: 400, overflowY: 'scroll', scrollbarWidth: 'auto'}}>
                        <table className="vto-table" id={"status-table"} style={{width: '100%', borderCollapse: 'collapse'}}>
                            <thead style={{position: 'sticky', top: 0, background: '#fff', zIndex: 1}}>
                                <tr>
                                    <th style={{width: 150}}>Status</th>
                                    <th style={{width: 150}}>Time</th>
                                    <th style={{width: 150}}>Slots</th>
                                    <th style={{width: 150}}>Classification</th>
                                    <th style={{width: 150}}>Duty Assigment</th>
                                </tr>
                            </thead>
                            {filteredList.length > 0 
                            ? (<tbody>
                                    {filteredList.map(offer => (
                                        <tr key={offer.id}>
                                            <td style={{paddingLeft: 10}}>
                                                {offer.status ? offer.status.charAt(0).toUpperCase() + offer.status.slice(1).toLowerCase() : ''}
                                            </td>
                                            <td>
                                                {offer.offerStartTime}-{offer.offerEndTime}
                                                {offer.offerStartDate !== offer.offerEndDate && (
                                                    <>
                                                        <span style={{color:'#0078d2'}}>*</span>
                                                        <br/>
                                                        <p className="end-date-note">*Offer Ends {offer.offerEndDate}</p>
                                                    </>
                                                )}
                                            </td>
                                            <td style={{paddingLeft: 10}}>
                                                {offer.slotsTaken}/{offer.slots}
                                            </td>
                                            <td style={{paddingLeft: 10}}>
                                                {offer.classification}
                                            </td>
                                            <td style={{paddingLeft: 10}}>
                                                {offer.dutyAssignment}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>)
                            :
                                <tbody>
                                    <tr>
                                        <td colSpan={5} style={{textAlign: 'center', padding: 10}}>
                                            No offers available for {dateShown}
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                    <p className="note" style={{margin: "10px 0px 0px 0px", color: "#36495A", fontFamily: "AmericanSans-Medium"}}>
                        Total Offers for {dateShown}: {filteredList.length}
                    </p>
                </>
            )}
        </aside>
    )
};

export default CurrentOffersComponent;
